import script from "./DeclaraGanador.vue?vue&type=script&setup=true&lang=js"
export * from "./DeclaraGanador.vue?vue&type=script&setup=true&lang=js"

import "./DeclaraGanador.vue?vue&type=style&index=0&id=40f8dbd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f8dbd9"]])

export default __exports__